export default [
    {
        name: 'alphaMap',
        type: 'texture',
        path: `/textures/alphaMap.webp`
    },
    {
        name: 'colorMap',
        type: 'texture',
        path: `/textures/colorMap.webp`
    },
    {
        name: 'vegetation',
        type: 'texture',
        path: `/textures/vegetation.webp`
    },
    {
        name: 'roughnessMap',
        type: 'texture',
        path: `/textures/roughnessMap.webp`
    },
    {
        name: 'heightMap',
        type: 'texture',
        path: `/textures/heightMap.webp`
    },
    {
        name: 'greenDetailMap',
        type: 'texture',
        path: `/textures/greenDetailMap.webp`
    },
    {
        name: 'fairwayDetailMap',
        type: 'texture',
        path: `/textures/fairwayDetailMap.webp`
    },
    {
        name: 'bunkerDetailMap',
        type: 'texture',
        path: `/textures/bunkerDetailMap.webp`
    },
    {
        name: 'waterNormalMap',
        type: 'texture',
        path: `/textures/waterNormalMap.webp`
    },
    {
        name: 'maskMap',
        type: 'texture',
        path: `/textures/mask.webp`
    },
    {
        name: 'treeA',
        type: 'texture',
        path: `/textures/treeA.webp`
    },
    {
        name: 'treeB',
        type: 'texture',
        path: `/textures/treeB.webp`
    },
    {
        name: 'batiments',
        type: 'data',
        path: `/data/batiments.geojson`
    },
    {
        name: 'tees',
        type: 'data',
        path: `/data/tees.geojson`
    },
    {
        name: 'bunkers',
        type: 'data',
        path: `/data/bunkers.geojson`
    },
    {
        name: 'holes',
        type: 'data',
        path: `/data/holes.geojson`
    },
    {
        name: 'info',
        type: 'data',
        path: `/data/info.json`
    },
    {
        name: 'presentation',
        type: 'data',
        path: `/data/presentation.json`
    },
    {
        name: 'ball',
        type: 'texture',
        path: `/textures/ball.webp`
    }
]